module.exports = __webpack_public_path__ + "static/media/earth-night.5350543d.jpg";